import React, { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { api } from "@/lib/api";

const Testimonials = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setList(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="testimonials-page">
      <section className="px-6 md:px-12 lg:px-20 pt-24 pb-16 md:pt-32">
        <p className="overline mb-6">Patient Stories</p>
        <h1 className="text-5xl sm:text-7xl tracking-tight font-light max-w-4xl leading-[1.05]">
          In their <em className="font-display italic" style={{ color: "var(--ayu-secondary)" }}>own words.</em>
        </h1>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {list.map((t) => (
            <article key={t.id} data-testid={`testimonial-card-${t.id}`} className="p-10" style={{ background: "var(--ayu-surface)" }}>
              <Quote size={28} strokeWidth={1} style={{ color: "var(--ayu-secondary)" }} className="mb-6" />
              <p className="font-display text-2xl leading-snug mb-8">"{t.quote}"</p>
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, i) => <Star key={i} size={14} fill="currentColor" style={{ color: "var(--ayu-secondary)" }} />)}
              </div>
              <p className="text-sm">{t.name} · <span className="opacity-70">{t.location}</span></p>
              <p className="text-xs opacity-60 mt-1">{t.treatment}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
